module.exports = __webpack_public_path__ + "img/gambia.3598fa83.png";